<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.overviews') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <div
        v-if="ready"
        class="col-md-12 p-0 m-0 row">

        <div class="col-md-12 col-lg-6">
          <div class="col-md-12 card">
            <div class="form-row mt-2">
              <div
                class="col-9"
                style="position: relative;">
                <div style="width: 1px;height: 50%;background: rgba(0,0,0,.1);position: absolute; top: 18px; right: 0;"/>
                <div class="mt-1 mb-1">
                  <strong style="font-size: 16px;">{{ $t('message.outstandinginvoice') }}</strong>
                </div>
                <div>
                  <span
                    class="text-info"
                    style="font-size: 28px;">{{ currencyFormatter(outstanding_invoice_total, {code: this.currency}) }}</span>
                </div>
              </div>
              <div class="col-3 text-center">
                <div
                  class="row align-items-center"
                  style="height: 100%;">
                  <div class="col">
                    <div>
                      {{ debits.outstanding_invoice.length }}
                    </div>
                    <div>
                      {{ $t('apps.accounts.message.totalinvoices') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr style="margin: 8px 0 0 0;">
            <div class="form-row mt-1">
              <div
                class="col-md-12"
                style="min-height: 250px;">
                <div
                  v-if="debits.outstanding_invoice.length == 0"
                  class="text-center mb-0"
                  style="height: 100%;">
                  <div
                    class="row align-items-center"
                    style="height: 100%;">
                    <div
                      class="col text-center"
                      style="position:relative;top:-16px;">
                      {{ $t('message.notfounddata') }}
                    </div>
                  </div>
                </div>
                <table
                  v-if="debits.outstanding_invoice.length > 0"
                  class="table mb-2"
                  style="border: none;">
                  <thead>
                    <tr>
                      <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.series') }}</strong>
                      </th>
                      <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.customer') }}</strong>
                      </th>
                      <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.debttotal') }}</strong>
                      </th>
                      <th
                        class="text-center"
                        style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.scheduled_at') }}</strong>
                      </th>
                      <!-- <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.grandtotal') }}</strong>
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in debits.outstanding_invoice">
                      <td style="border: none;padding: 5px 0 5px 0;">
                        <router-link-custom
                          :to="{name: 'AccountsInvoiceEdit', query: {
                            in_id: item.in_id,
                            in_code: item.in_code
                          }}"
                          :text="item.in_code"
                          :status="{
                            text: getInvoiceStatus(item, $t, mixin).message,
                            color: getColorFormStatus(getInvoiceStatus(item, $t, mixin).status),
                            type: 'icon'
                          }"
                          :to_appid="12"
                          :current_appid="12"/>
                      </td>
                      <td style="border: none;padding: 5px 0 5px 0;">
                        <router-link-custom
                          v-if="item.customer"
                          :to="{name: 'ContactCustomerEdit', query: {cus_id: item.customer.customer_id, cus_name: item.customer.customer_name}}"
                          :text="item.customer.customer_name"
                          :to_appid="11"
                          :current_appid="12"
                          :disabled="item.customer.is_deleted == true" />
                      </td>
                      <td style="border: none;padding: 5px 0 5px 0;">
                        {{ getNumber(getDebtInvoiceAmount(item)) }}
                      </td>
                      <td
                        class="text-center"
                        style="border: none;padding: 5px 0 5px 0;">
                        {{ getDate(item.scheduled_at) }}
                      </td>
                      <!-- <td style="border: none;padding: 5px 0 5px 0;">
                        {{ getNumber(getTotal(item.orders).payment) }}
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-lg-6">
          <div class="col-md-12 card">
            <div class="form-row mt-2">
              <div
                class="col-9"
                style="position: relative;">
                <div style="width: 1px;height: 50%;background: rgba(0,0,0,.1);position: absolute; top: 18px; right: 0;"/>
                <div class="mt-1 mb-1">
                  <strong style="font-size: 16px;">{{ $t('message.outstandingpayment') }}</strong>
                </div>
                <div>
                  <span
                    class="text-info"
                    style="font-size: 28px;">{{ currencyFormatter(outstanding_payment_total, {code: this.currency}) }}</span>
                </div>
              </div>
              <div class="col-3 text-center">
                <div
                  class="row align-items-center"
                  style="height: 100%;">
                  <div class="col">
                    <div>
                      {{ debits.outstanding_payment.length }}
                    </div>
                    <div>
                      {{ $t('apps.accounts.message.totalpayments') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr style="margin: 8px 0 0 0;">
            <div class="form-row mt-1">
              <div
                class="col-md-12"
                style="min-height: 250px;">
                <div
                  v-if="debits.outstanding_payment.length == 0"
                  class="text-center mb-0"
                  style="height: 100%;">
                  <div
                    class="row align-items-center"
                    style="height: 100%;">
                    <div
                      class="col text-center"
                      style="position:relative;top:-16px;">
                      {{ $t('message.notfounddata') }}
                    </div>
                  </div>
                </div>
                <table
                  v-if="debits.outstanding_payment.length > 0"
                  class="table mb-2"
                  style="border: none;">
                  <thead>
                    <tr>
                      <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.series') }}</strong>
                      </th>
                      <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.vendor') }}</strong>
                      </th>
                      <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.debttotal') }}</strong>
                      </th>
                      <th
                        class="text-center"
                        style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.scheduled_at') }}</strong>
                      </th>
                      <!-- <th style="border-top: 1px solid rgba(0,0,0,.1);border: none;padding: 5px 0 5px 0;">
                        <strong style="color: #999;">{{ $t('message.grandtotal') }}</strong>
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in debits.outstanding_payment">
                      <td style="border: none;padding: 5px 0 5px 0;">
                        <template>
                          <router-link-custom
                            v-if="item.po_id"
                            :to="{name: 'PurchaseOrderEdit', query: {
                              id: item.po_id,
                              code: item.po_code
                            }}"
                            :text="item.po_code"
                            :status="{
                              text: getPurchaseStatus(item, $t, mixin).message,
                              color: getColorFormStatus(getPurchaseStatus(item, $t, mixin).status),
                              type: 'icon'
                            }"
                            :to_appid="4"
                            :current_appid="4" />

                          <router-link-custom
                            v-if="item.ex_id"
                            :to="{name: 'ExpensesClaimEdit', query: {
                              ex_id: item.ex_id,
                              ex_code: item.ex_code
                            }}"
                            :text="item.ex_code"
                            :status="{
                              text: getExpenseStatus(item, $t, mixin).message,
                              color: getColorFormStatus(getExpenseStatus(item, $t, mixin).status),
                              type: 'icon'
                            }"
                            :to_appid="6"
                            :current_appid="6" />

                          <router-link-custom
                            v-if="item.prl_id"
                            :to="{name: 'PaySlipEdit', query: {
                              id: item.prl_id,
                              code: item.prl_code,
                            }}"
                            :text="item.prl_code"
                            :status="{
                              text: $t(`process.prl.${item.process.status}`),
                              color: getColorFormStatus('uncompleted'),
                              type: 'icon'
                            }"
                            :to_appid="14"
                            :current_appid="6" />
                        </template>
                      </td>
                      <td style="border: none;padding: 5px 0 5px 0;">
                        <template>
                          <router-link-custom
                            v-if="item.vendor && item.po_id"
                            :to="{name: 'ContactVendorEdit', query: {ven_id: item.vendor.vendor_id, ven_name: item.vendor.vendor_name}}"
                            :text="item.vendor.vendor_name"
                            :to_appid="11"
                            :current_appid="4"
                            :disabled="item.vendor.is_deleted == true" />
                          <span v-if="item.ex_id">-</span>
                          <span v-if="item.prl_id">-</span>
                        </template>
                      </td>
                      <td style="border: none;padding: 5px 0 5px 0;">
                        <template>
                          <span v-if="item.po_id">{{ getNumber(getDebtPurchaseAmount(item)) }}</span>
                          <span v-if="item.ex_id">{{ getNumber(getDebtExpenseAmount(item)) }}</span>
                          <span v-if="item.prl_id">{{ getNumber(getDebtPayslipAmount(item)) }}</span>
                        </template>
                      </td>
                      <td
                        class="text-center"
                        style="border: none;padding: 5px 0 5px 0;">
                        {{
                          item.prl_id ?
                            '-' :
                            getDate(item.scheduled_at)
                        }}
                      </td>
                      <!-- <td style="border: none;padding: 5px 0 5px 0;">
                        <template>
                          <span v-if="item.po_id">{{ getNumber(getTotal(item.orders).payment) }}</span>
                          <span v-if="item.ex_id">{{ getNumber(item.payment.amount) }}</span>
                        </template>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'

export default {
  name: 'AccountsOverviewAll',
  data () {
    return {
      ready: false,
    }
  },
  computed: {
    ...mapGetters({
      debits: 'getDebits',
      getInvoiceStatus: 'getInvoiceStatus',
      getPurchaseStatus: 'getPurchaseStatus',
      getExpenseStatus: 'getExpenseStatus',
      currency: 'getCurrency',
    }),
    outstanding_invoice_total () {
      var total = 0

      if (!this.debits) return 0

      this.debits.outstanding_invoice.map(object => {
        total += this.getDebtInvoiceAmount(object)
      })

      return total
    },
    outstanding_payment_total () {
      var total = 0

      if (!this.debits) return 0

      this.debits.outstanding_payment.map(object => {
        if (object.po_id) {
          total += this.getDebtPurchaseAmount(object)
        } else if (object.ex_id) {
          total += this.getDebtExpenseAmount(object)
        } else if (object.prl_id) {
          total += this.getDebtPayslipAmount(object)
        }
      })

      return total
    },
  },
  methods: {
    ...mapActions([

    ]),

  },
  watch: {
    ready: function (after) {
      if (after == true) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    // get debits
    await this.$store.dispatch('getDebits')
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
#content .content {
  padding-top: 18px;
  padding-left: 15px;
  padding-right: 15px;
}
.card {
  background: #FFF;
  border: solid 1px #D8E2E7;
  border-radius: 2px;
  padding: 0px 15px 0px 15px;
  margin: 10px 0 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/overview/All.vue